import React from "react";

const WhatsAvailable: React.FC = () => {
  return (
    <section className="secondary-page lg:mb-20">
      <div className="max-w-6xl mx-auto">
          <h1>What's available now?</h1>
          <div className="l0-section-text">
            <ul className="l0-list">
              <li>12-month subscription</li>
              <li>Includes access to Bronze, Silver, and Gold certifications</li>
            </ul>
        </div>
      </div>
    </section>
  );
};

WhatsAvailable.displayName = "WhatsAvailable";

export default WhatsAvailable;
